import { injector } from '@asd-stan/injector/injector';

import { AuthRepo } from '../api/auth.repo';
import { AuthService } from '../domain/auth.service';

import { AUTH_REPO, AUTH_SERVICE } from './constants';

injector.set(AUTH_REPO, new AuthRepo());
injector.set(AUTH_SERVICE, new AuthService());
